var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm.proccess == "START"
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Calcolatore preventivi")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\n          Compila i seguenti step. In caso di conferma del preventivo tutti i\n          dati inseriti verranno poi utilizzati per generare i documenti\n          richiesti per lo sconto in fattura.\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0 !important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mt-0 pb-2 formp",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva preventivo",
                        stepSize: _vm.stepSize,
                        color: "#00337f",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": _vm.onComplate
                      }
                    },
                    [
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Scegli Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pb-0 center section-heading"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Clicca sull`icona del bonus al quale vuoi aderire.\n                  "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Bonus Casa 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Bonus Casa\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/50w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 65% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 65%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/65.png")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: require("../../assets/images/65w.png")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{ required: true, max: 63, min: 2 }"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le quattro icone\n                      sopraindicate.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-3" },
                                        [
                                          _vm._v(
                                            "\n                  Novatag e KPMG, non si ritengono responsabili per eventuali\n                  danni economici derivanti dall.utilizo della piattaforma e\n                  dall.informazioni fornite.\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      3 == 3
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci i dati del cliente finale\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_type,
                                                        expression:
                                                          "client_type"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{ required: true, max: 63, min: 2 }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_type"
                                                      ),
                                                      valid: !!_vm.client_type
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "client_type",
                                                      name: "client_type",
                                                      "data-vv-as":
                                                        "Tipologia cliente"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.client_type = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Amministratore di condominio"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Condominio (Amministratore)\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Persona fisica"
                                                        }
                                                      },
                                                      [_vm._v("Persona fisica")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value:
                                                                "Partita IVA"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Partita IVA\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_type"
                                                    }
                                                  },
                                                  [_vm._v("Tipologia cliente")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_type"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_type"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientName,
                                                      expression: "clientName"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientName"
                                                    ),
                                                    valid: !!_vm.clientName
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientName",
                                                    name: "clientName",
                                                    "data-vv-as": "Nome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientName =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "clientName" }
                                                  },
                                                  [_vm._v("Nome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientName"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientName"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientLastname,
                                                      expression:
                                                        "clientLastname"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientLastname"
                                                    ),
                                                    valid: !!_vm.clientLastname
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientLastname",
                                                    name: "clientLastname",
                                                    "data-vv-as": "Cognome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientLastname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientLastname =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "clientLastname"
                                                    }
                                                  },
                                                  [_vm._v("Cognome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientLastname"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientLastname"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_email,
                                                      expression: "client_email"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        email: true,
                                                        temporaryEmail: true,
                                                        plusIssueEmail: true,
                                                        max: 56
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        email: true,\n                        temporaryEmail: true,\n                        plusIssueEmail: true,\n                        max: 56,\n                      }"
                                                    }
                                                  ],
                                                  ref: "client_email",
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_email"
                                                    ),
                                                    valid: !!_vm.client_email
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_email",
                                                    name: "client_email",
                                                    "data-vv-as": "Email"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_email"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Email*\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_email"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_email"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_phone,
                                                      expression: "client_phone"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[0]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: false,\n                        max: 12,\n                        min: 8,\n                        regex: /^[0]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_phone"
                                                    ),
                                                    valid: !!_vm.client_phone
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_phone",
                                                    name: "client_phone",
                                                    "data-vv-as": "Telefono"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_phone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_phone =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_phone"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Telefono\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_phone"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_phone"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_mobile,
                                                      expression:
                                                        "client_mobile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[3]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        max: 12,\n                        min: 8,\n                        regex: /^[3]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_mobile"
                                                    ),
                                                    valid: !!_vm.client_mobile
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_mobile",
                                                    name: "client_mobile",
                                                    "data-vv-as": "Cellulare"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_mobile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_mobile =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_mobile"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Cellulare *\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_mobile"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_mobile"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.ecoBonus != "Bonus Casa 50%"
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "usoAbitativo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Prevalente uso abitativo\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("SI")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("NO")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-1.usoAbitativo"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-1.usoAbitativo')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Il servizio deve essere accettato oppure rifiutato\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black pb-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci l'indirizzo dell'immobile\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.province,
                                                        expression: "province"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.province"
                                                      ),
                                                      valid: !!_vm.province
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomy",
                                                      id: "province",
                                                      name: "province",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.province = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.provincies,
                                                      function(province) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: province.sigla,
                                                            domProps: {
                                                              value:
                                                                province.sigla
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  province.sigla
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  province.provincia
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "province" }
                                                  },
                                                  [_vm._v("Provincia")]
                                                ),
                                                _vm._v(" "),
                                                _vm.provinciesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id:
                                                                "loadProvince",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.province"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.province"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.cityError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli Provincia"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.city,
                                                        expression: "city"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.city"
                                                      ),
                                                      valid: !!_vm.city
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomu",
                                                      id: "city",
                                                      name: "city",
                                                      "data-vv-as": "Località",
                                                      disabled: _vm.citiesState
                                                    },
                                                    on: {
                                                      click: _vm.checkProvince,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.city = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.cities, function(
                                                      city
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: city.comune,
                                                          domProps: {
                                                            value: {
                                                              cityistat:
                                                                city.istat,
                                                              city: city.comune
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                city.comune
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "city" }
                                                  },
                                                  [_vm._v("Località")]
                                                ),
                                                _vm._v(" "),
                                                _vm.citiesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadCity",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.city")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.city"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.zipError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli città"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zip,
                                                        expression: "zip"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.zip"
                                                      ),
                                                      valid: !!_vm.zip
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomi",
                                                      id: "zip",
                                                      name: "zip",
                                                      "data-vv-as": "Cap",
                                                      disabled: _vm.zipsState
                                                    },
                                                    on: {
                                                      click: _vm.checkZip,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.zip = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        selected: true
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.zips, function(
                                                      zip
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: zip.cap,
                                                          domProps: {
                                                            value: zip.cap
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(zip.cap) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "zip" }
                                                  },
                                                  [_vm._v("Cap")]
                                                ),
                                                _vm._v(" "),
                                                _vm.zipsState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadZips",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.zip")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.zip"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.adress,
                                                      expression: "adress"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 128,
                                                        min: 5
                                                      },
                                                      expression:
                                                        "{ required: true, max: 128, min: 5 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.adress"
                                                    ),
                                                    valid: !!_vm.adress
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "adress",
                                                    name: "adress",
                                                    "data-vv-as": "Indirizzo"
                                                  },
                                                  domProps: {
                                                    value: _vm.adress
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.adress =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "adress" }
                                                  },
                                                  [_vm._v("Indirizzo")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.adress")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.adress"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.civic,
                                                      expression: "civic"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 15,
                                                        min: 1
                                                      },
                                                      expression:
                                                        "{ required: true, max: 15, min: 1 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.civic"
                                                    ),
                                                    valid: !!_vm.civic
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "civic",
                                                    name: "civic",
                                                    "data-vv-as": "Civico"
                                                  },
                                                  domProps: {
                                                    value: _vm.civic
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.civic =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "civic" }
                                                  },
                                                  [_vm._v("Civico")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.civic")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.civic"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        })
                                      ])
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("LISTA DOCUMENTI")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Dati Intervento",
                            icon: "",
                            "before-change": _vm.validateSecondTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull orangeBg",
                              attrs: {
                                "data-vv-scope": "form-2",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci i dati dell'intervento\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.eventType,
                                                expression: "eventType"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-2.eventType"
                                              ),
                                              valid: !!_vm.eventType
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "eventType",
                                              name: "eventType",
                                              "data-vv-as": "Tipo di intervento"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.eventType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "sostituzione" }
                                              },
                                              [_vm._v("Sostituzione")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "Instalazione" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Nuova Installazione\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "eventType" }
                                          },
                                          [_vm._v("Tipo di intervento")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-2.eventType")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-2.eventType"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci Beni Significativi\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "widthFull" },
                                        _vm._l(_vm.products, function(
                                          elem,
                                          num
                                        ) {
                                          return _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: elem.group,
                                                              expression:
                                                                "elem.group"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{ required: true, is_not: '' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.g" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.group
                                                          },
                                                          attrs: {
                                                            id:
                                                              "g" + elem.index,
                                                            name:
                                                              "g" + elem.index,
                                                            "data-vv-as":
                                                              "Gruppo"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "group",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setGroup(
                                                                  elem.index
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _vm.ecoBonus ==
                                                          "Ecobonus 50%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item,
                                                                    ii
                                                                  ) {
                                                                    return [
                                                                      item.value ==
                                                                        "condensazione" ||
                                                                      item.value ==
                                                                        "altroVaillant"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              key: ii,
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : _vm.ecoBonus ==
                                                              "Ecobonus 65%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value !=
                                                                      "tradizionale"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "group"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli gruppo prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.g" + elem.index
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.g" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull black pointer m-0",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.insertProductCode(
                                                                elem.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "search",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.insertProductCode(
                                                                    elem.index
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              "o cerca con codice prodotto "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-5" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      elem.group != "ibridi" &&
                                                      elem.group !=
                                                        "altroVaillant"
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : elem.group ==
                                                          "altroVaillant"
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product
                                                                    .name,
                                                                expression:
                                                                  "elem.product.name"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  is_not: ""
                                                                },
                                                                expression:
                                                                  "{ required: true, is_not: '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.p" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id:
                                                                "p" +
                                                                elem.index,
                                                              name:
                                                                "p" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Prodotto"
                                                            },
                                                            domProps: {
                                                              value:
                                                                elem.product
                                                                  .name
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              },
                                                              click:
                                                                _vm.checkIfEmpty,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  elem.product,
                                                                  "name",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloPompaDiCalore
                                                                        ) +
                                                                        " +\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloCaldaiaACondensazione
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "product"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli Prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ) && !elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.p" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Prima scegli gruppo\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mr-md-0 pr-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.quantity,
                                                            expression:
                                                              "elem.quantity"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0",
                                                              min_value: 1,
                                                              max: 4
                                                            },
                                                            expression:
                                                              "{\n                              required: true,\n                              is_not: '0',\n                              min_value: 1,\n                              max: 4,\n                            }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.q" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.quantity
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          id:
                                                            "q" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "q" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Quantità"
                                                        },
                                                        domProps: {
                                                          value: elem.quantity
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.calcTotalPriceProducts()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "quantity",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Quantità")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.q" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 pl-md-0 ml-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.price,
                                                            expression:
                                                              "elem.price"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0"
                                                            },
                                                            expression:
                                                              "{ required: true, is_not: '0' }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.i" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.price
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id:
                                                            "i" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "i" +
                                                            elem.indexCount,
                                                          "data-vv-as": "Prezzo"
                                                        },
                                                        domProps: {
                                                          value: elem.price
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.formatPrice(
                                                              elem.index
                                                            ),
                                                              _vm.calcTotalPriceProducts()
                                                          },
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.keymonitor(
                                                              $event,
                                                              elem.index,
                                                              "prod"
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Prezzo €")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "widthFull center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            (IVA esclusa)\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.i" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "removeProduct pointer",
                                                      class: elem.index
                                                    },
                                                    [
                                                      num != 0
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "trash-alt",
                                                                size: "lg"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeProduct(
                                                                    num
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: { click: _vm.addProduct }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: { click: _vm.addProduct }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi prodotto\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo prodotti (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalProducts) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Inserisci altri Beni/Accessori opzionali\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.accessories, function(
                                        elem,
                                        num
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.group,
                                                            expression:
                                                              "elem.group"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {},
                                                            expression: "{}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.ac" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.group
                                                        },
                                                        attrs: {
                                                          id: "ac" + elem.index,
                                                          name:
                                                            "ac" + elem.index,
                                                          "data-vv-as":
                                                            "accessori opzionali"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "group",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setTypeAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessori,
                                                        function(item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected:
                                                                  "selected"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    item.name
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "group" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Scegli accessori opzionali"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ac" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ac" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "widthFull black pointer m-0",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.insertAccessoriesCode(
                                                              elem.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "search",
                                                              size: "sm"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.insertAccessoriesCode(
                                                                  elem.index
                                                                )
                                                              }
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "o cerca con codice accessorio "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product,
                                                                expression:
                                                                  "elem.product"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required:
                                                                    elem.group !=
                                                                    ""
                                                                },
                                                                expression:
                                                                  "{ required: elem.group != '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.ap" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              id:
                                                                "ap" +
                                                                elem.index,
                                                              name:
                                                                "ap" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Accessorio"
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    elem,
                                                                    "product",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setAccessories(
                                                                    elem.index
                                                                  )
                                                                }
                                                              ],
                                                              click:
                                                                _vm.checkIfEmpty
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .itemsAccessories[
                                                              elem.index
                                                            ],
                                                            function(
                                                              item,
                                                              ind
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value: {
                                                                      index: ind,
                                                                      name:
                                                                        item.Modello,
                                                                      serial:
                                                                        item.codice
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        item.Modello
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product
                                                                  .name,
                                                              expression:
                                                                "elem.product.name"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required:
                                                                  elem.group !=
                                                                  "",
                                                                max: 128
                                                              },
                                                              expression:
                                                                "{\n                            required: elem.group != '',\n                            max: 128,\n                          }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.ap" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem
                                                              .product.name
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            id:
                                                              "ap" + elem.index,
                                                            name:
                                                              "ap" + elem.index,
                                                            "data-vv-as":
                                                              "Accessorio"
                                                          },
                                                          domProps: {
                                                            value:
                                                              elem.product.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                elem.product,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Scegli Accessorio"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Inserisci Accessorio"
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ) && !elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ap" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Prima scegli tipo\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 mr-md-0 pr-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.quantity,
                                                          expression:
                                                            "elem.quantity"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0",
                                                            min_value: 1,
                                                            max: 4
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                            min_value: 1,\n                            max: 4,\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.aq" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.quantity
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        id:
                                                          "aq" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "aq" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Quantità"
                                                      },
                                                      domProps: {
                                                        value: elem.quantity
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.calcTotalPriceAccessories()
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "quantity",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Quantità")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.aq" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.aq" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 pl-md-0 ml-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.price,
                                                          expression:
                                                            "elem.price"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0"
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.ai" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.price
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id:
                                                          "ai" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "ai" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Prezzo"
                                                      },
                                                      domProps: {
                                                        value: elem.price
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.formatPriceAccessories(
                                                            elem.index
                                                          )
                                                          _vm.calcTotalPriceAccessories()
                                                        },
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          return _vm.keymonitor(
                                                            $event,
                                                            elem.index,
                                                            "accs"
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "price",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Prezzo €")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "widthFull center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          (IVA esclusa)\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ai" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ai" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "removeProduct pointer",
                                                    class: elem.index
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAccessories(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: {
                                                  click: _vm.addAccessories
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: {
                                                    click: _vm.addAccessories
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi accessorio\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo accessori opzionali (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAccessories) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("Pratica ENEA")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceEnea,
                                                      expression: "priceEnea"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceEnea"
                                                    ),
                                                    valid: !!_vm.priceEnea
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceEnea",
                                                    name: "priceEnea",
                                                    "data-vv-as":
                                                      "Costo Gestione Pratica ENEA"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceEnea
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceEnea()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceEnea =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceEnea" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Costo Gestione Pratica ENEA"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    "Valore che sarà addebitato al cliente "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceEnea"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceEnea"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.NoEnea
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "datiCatastali"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Servizio di redazione e invio pratica ENEA ad un\n                            costo di €50 +IVA ( costo che ti sarà addebitato\n                            se accetti il servizio )\n                          "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "NON ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-2.enea"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-2.enea')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Il servizio deve essere accettato oppure rifiutato\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Installazione e Posa in Opera\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceWork,
                                                      expression: "priceWork"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceWork"
                                                    ),
                                                    valid: !!_vm.priceWork
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceWork",
                                                    name: "priceWork",
                                                    "data-vv-as":
                                                      "Importo installazione/posa in opera"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceWork
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceWork()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceWork =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceWork" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera ( IVA esclusa\n                          )"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceWork"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceWork"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceDcast
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                    "\n                        €\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-2 pb-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Riepilogo aliquote IVA\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_lavoro,
                                                          expression:
                                                            "iva_age_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_age_lavoro
                                                      },
                                                      attrs: {
                                                        id: "iva_age_lavoro",
                                                        name: "iva_age_lavoro",
                                                        "data-vv-as":
                                                          "Beni significativi, quota concorrente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_extra,
                                                          expression:
                                                            "iva_age_extra"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_extra"
                                                        ),
                                                        valid: !!_vm.iva_age_extra
                                                      },
                                                      attrs: {
                                                        id: "iva_age_extra",
                                                        name: "iva_age_extra",
                                                        "data-vv-as":
                                                          "Beni significativi, quota eccedente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_extra = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_accessori_lavoro,
                                                          expression:
                                                            "iva_accessori_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_accessori_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_accessori_lavoro
                                                      },
                                                      attrs: {
                                                        id:
                                                          "iva_accessori_lavoro",
                                                        name:
                                                          "iva_accessori_lavoro",
                                                        "data-vv-as":
                                                          "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_accessori_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri oneri per il Committente\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_altri_oneri,
                                                          expression:
                                                            "iva_altri_oneri"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_altri_oneri"
                                                        ),
                                                        valid: !!_vm.iva_altri_oneri
                                                      },
                                                      attrs: {
                                                        id: "iva_altri_oneri",
                                                        name: "iva_altri_oneri",
                                                        "data-vv-as":
                                                          "Altri oneri per il Committente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_altri_oneri = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.client_type ==
                                                "Persona fisica" &&
                                              _vm.usoAbitativo == 1 &&
                                              (_vm.iva_altri_oneri == "0.04" ||
                                                _vm.iva_accessori_lavoro ==
                                                  "0.04" ||
                                                _vm.iva_age_extra == "0.04" ||
                                                _vm.iva_age_lavoro == "0.04")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 mb-3 center text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "Bold center"
                                                        },
                                                        [_vm._v("Attenzione!")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          "Non tutti gli acquisti e interventi, a prescindere,\n                        possono essere considerati secondo l’aliquota\n                        agevolata al 4% bensì esclusivamente quelli\n                        prettamente collegati alla specifica disabilità del\n                        cliente finale.\n                      "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _c("br"),
                                                      _c(
                                                        "b",
                                                        { staticClass: "red" },
                                                        [
                                                          _vm._v(
                                                            "Occorre, pertanto, verificare la tipologia di\n                        intervento da eseguire per verificare se il cliente\n                        potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mt-2 center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Consulta la\n                        "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "Bold underline black",
                                                              attrs: {
                                                                href:
                                                                  "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [_vm._v("guida")]
                                                          ),
                                                          _vm._v(
                                                            "\n                        relativa alle agevolazioni fiscali per le persone con\n                        disabilità.\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _vm.requiredOperations
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 mb-3 requiredCont"
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "green" },
                                                  [
                                                    _vm._v(
                                                      "\n                        Requisiti tecnici richiesti per aderire al bonus:\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("h5", {
                                                  staticClass: "black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.requiredOperations
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Anteprima",
                            subtitle: "Tutti i campi sono obbligatori",
                            icon: "",
                            "before-change": _vm.validateThirdTab
                          }
                        },
                        [
                          _vm.calcFinish
                            ? _c(
                                "form",
                                {
                                  staticClass: "widthFull orio pt-3 pr-md-3",
                                  attrs: {
                                    "data-vv-scope": "form-3",
                                    autocomplete: "qwerqrt3"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "invoiceData",
                                      staticClass: "widthFull"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider fordelete"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 mt-4"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Cessionario/prestatore (fornitore)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Identificativo fiscale ai fini IVA:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("IT03402390409")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Denominazione: "),
                                                  _c("b", [
                                                    _vm._v("EMICON A.C. S.p.A.")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Indirizzo:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("Via A. Volta, 49")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Comune:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("Meldola (FC) Italy")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [_vm._v("47014")]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.email
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cellulare: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.cellulare
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("IBAN: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.iban
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm.getProfile.logo
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "50% !important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.getProfile.logo
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Benificiario/committente (cliente)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Denominazione:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.clientName) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.clientLastname
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Indirizzo: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.adress) +
                                                        " " +
                                                        _vm._s(_vm.civic)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Comune: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.city.city) +
                                                        " (" +
                                                        _vm._s(_vm.province) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.zip))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.client_email)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_phone
                                                    ? _c("span", [
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_phone
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_mobile
                                                    ? _c("span", [
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_mobile
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left pt-4 h0 black"
                                        },
                                        [_c("b", [_vm._v("La tua offerta:")])]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario == "si"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89\n                  della Legge n. 190/2014, così come modificato dalla Legge\n                  numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\n                "
                                              )
                                            ]
                                          )
                                        : _vm.client_type == "Partita IVA" &&
                                          _vm.iva_age_lavoro == "0.00" &&
                                          _vm.iva_age_extra == "0.00"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione soggetta al reverse charge art. 17, comma 6,\n                  lett. a-ter DPR 633/1972.\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead"),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Beni significativi"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.products, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.totalProducts
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Agevolabile Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalProducts
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) -
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Altri beni ed accessori"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.accessories, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", {
                                                  attrs: { scope: "row" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.priceWork
                                                          ) +
                                                          " € "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale altri beni ed accessori\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.totalAccessories
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ) +
                                                              parseFloat(
                                                                _vm.priceWork
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale intervento\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "imponibile"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "220",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBase
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [_vm._v("Riepilogo")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", {
                                                    attrs: {
                                                      align: "left",
                                                      scope: "row"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm._v(
                                                            "Importo\n                          "
                                                          ),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                          "si"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Aliquota IVA")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Totale (IVA Inclusa)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_lavoro)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_lavoro
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_extra)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_extra *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_extra
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_extra
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.totalAccessories
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                                parseFloat(
                                                                  _vm.priceWork
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                )
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_accessori_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                (parseFloat(
                                                                  _vm.totalAccessories
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.priceWork
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  )) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_accessori_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale fattura Spesa agevolabile\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "(IVA INCLUSA)"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBaseAndIva
                                                              )
                                                            ) +
                                                              "\n                            €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        { staticClass: "table table-bordered" },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "uppercase",
                                                  attrs: {
                                                    colspan: "2",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Sconto in fattura " +
                                                      _vm._s(this.ecoBonus) +
                                                      "\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        this.client_type ==
                                                          "Partita IVA" &&
                                                        this.usoAbitativo ==
                                                          0 &&
                                                        this.iva_age_lavoro ==
                                                          "0.22" &&
                                                        this.iva_age_extra ==
                                                          "0.22" &&
                                                        this
                                                          .iva_accessori_lavoro ==
                                                          "0.22"
                                                          ? void 0
                                                          : [
                                                              _vm._v(
                                                                " (IVA INCLUSA)"
                                                              )
                                                            ]
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 121, D.L. 34/20 convertito con Legge 17 luglio\n                          2020)\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.calcInfo
                                                            .totalWithBonus
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale fattura al committente per bonifico parlante\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus ==
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 16 bis, D.P.R. 917/86)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus !=
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 1, Legge 296/2006 e art. 14 D.L.\n                            63/2013)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .totalBaseAndIva
                                                            ) -
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .totalWithBonus
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Altri oneri per il committente"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "2",
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Quota spesa non agevolata\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.totalExtraMise
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva22NonAge
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva10NonAge
                                                            )
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                          €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm._v(
                                                    "\n                        Gestione Pratica ENEA\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.zeroEnea,
                                                            expression:
                                                              "zeroEnea"
                                                          }
                                                        ],
                                                        key: "1111",
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "zeroEnea"
                                                        },
                                                        domProps: {
                                                          checked: Array.isArray(
                                                            _vm.zeroEnea
                                                          )
                                                            ? _vm._i(
                                                                _vm.zeroEnea,
                                                                null
                                                              ) > -1
                                                            : _vm.zeroEnea
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.zeroEnea,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.zeroEnea = $$a.concat(
                                                                    [$$v]
                                                                  ))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.zeroEnea = $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                              }
                                                            } else {
                                                              _vm.zeroEnea = $$c
                                                            }
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          attrs: {
                                                            for: "zeroEnea"
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Escludi questa voce dal preventivo"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            (
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm.priceEnea
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Oneri Finanziari\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [_vm._v("(IVA ESENTE)")]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroOneri"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "oneri"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Costi di gestione pratica\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroPratica"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "pratica"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale altri oneri per il committente\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA " +
                                                                  _vm._s(
                                                                    _vm.iva_altri_oneri *
                                                                      100
                                                                  ) +
                                                                  " %\n                            INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario != "si"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row ml-0 mr-0 pt-2" },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale da pagare "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            ( a carico dell’utente finale\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    ", IVA inclusa"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                            )"
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .finalPrice
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mb-0 mt-3 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm.getProfile
                                                          .reg_forfettario ==
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "\n                            Operazione in franchigia da Iva ex art. 1 cc.\n                            54-89 L. 190/2014\n                          "
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n\n                          L’utilizzo dei servizi descritti sul Sito comporta\n                          l’integrale accettazione dei\n                          "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "green",
                                                            attrs: {
                                                              href:
                                                                _vm.utilizzoPolicy,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Termini e delle condizioni di riferimento\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "widthFull mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center"
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered"
                                          },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      "\n                          IMPORTO TOTALE DEL CREDITO CEDUTO\n                          "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalWithBonus
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75574de3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75574de3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/emicon.vue
// module id = null
// module chunks = 